<template>
  <v-card
    :class="[$vuetify.breakpoint.mobile ? 'my-2' : 'my-12 pt-10', 'mx-auto']"
    color="#173862"
    elevation="0"
    width="400"
  >
    <v-card-text
      :class="[$vuetify.breakpoint.mobile ? 'pt-2' : 'pt-10', 'ml-3 mr-2 font-weight-normal white--text']"
    >
      <!-- <ul class="ml-3 mr-2 pt-10 font-weight-normal white--text"> -->
      <ul>
        <li>{{ $t('login.li1') }}</li>
        <li>{{ $t('login.li2') }}</li>
        <li>{{ $t('login.li3') }}</li>
        <li>{{ $t('login.li4') }}</li>
      </ul>
      <!-- <p class="pa-2"><v-icon color="orange" class="px-4">mdi-thumb-up</v-icon>{{ $t('login.li1') }}</p>
      <p class="pa-2"><v-icon color="orange" class="px-4">mdi-thumb-up</v-icon>{{ $t('login.li2') }}</p>
      <p class="pa-2"><v-icon color="orange" class="px-4">mdi-thumb-up</v-icon>{{ $t('login.li3') }}</p>
      <p class="pa-2"><v-icon color="orange" class="px-4">mdi-thumb-up</v-icon>{{ $t('login.li4') }}</p> -->
    </v-card-text>

    <v-card-actions>
      <v-row
        align="center"
        justify="center"
      >
        <router-link to="/registration" class="text-decoration-none">
          <v-btn 
            color="#F2A81D"
            class="ma-5 font-weight-normal"
            large
          >{{ $t('login.startTrial') }}</v-btn>
        </router-link>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    
  }
</script>

<style lang="scss" scoped>
  ul {
    list-style: none;
    // font-size: 22px;
  }

  ul li::before {
    content: "\2022";
    color: #F2A81D;
    display: inline-block; 
    width: 1em;
    margin-left: -1em;
  }

  li, p {
    margin-top: 28px;
    text-align: left;
    font-size: 22px;
  }

  ::v-deep .v-btn__content {
    font-size: 22px;
  }
</style>